import React from "react";
import { Navigate } from "react-router-dom";


const SuperAdminProtectedRoute = ({ component: Component, ...rest }) => {
    const userDetails = JSON.parse(localStorage.getItem("userDetails"));
    const is_Auth = userDetails?.accessToken;
    const is_SuperAdmin = userDetails?.role === "super_admin";

  return is_Auth && is_SuperAdmin ? <Component {...rest} /> : <Navigate to="/" />;
};

export default SuperAdminProtectedRoute;
